<template>
  <div v-loading.body="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="上传excel" name="batchorderfencang"></el-tab-pane>
      <el-tab-pane label="已上传列表" name="waitshiplist"></el-tab-pane>
    </el-tabs>

    <el-row class="filter">
      <div
        style="
          width: 300px;
          margin-left: 10%;
          margin-top: 20px;
          margin-bottom: 40px;
        "
      >
        <p style="font-size: 30px">{{ resData.origin }}发货</p>
        <el-form :model="form">
          <el-form-item label="快递公司">
            <el-select
              v-model="form.shipping_name"
              placeholder="请选择快递公司"
            >
              <el-option
                v-for="shipping in resData.shipping_company"
                :key="shipping.shipping_name"
                :label="shipping.shipping_company"
                :value="shipping.shipping_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入快递单">
            <el-upload
              class="upload-demo"
              :action="action"
              name="excel"
              accept=".xls,.xlsx,.csv"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :limit="1"
              :on-exceed="handleExceed"
              :on-success="uploadSuccess"
              :before-upload="beforeUpload"
              :file-list="fileList"
              with-credentials
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-button type="primary" @click="onSubmit">批量发货</el-button>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      activeName: "",
      curName: "batchorderfencang",
      resData: {
        origin: "",
      },
      form: {
        filelist: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Order/batchOrderFencang",
      filterFold: false,
      fileList: [],
      action: `${apiBaseURL}/erp/WavePicking/importFile`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleClick(tab, event) {
      if (tab.$options.propsData.name != this.curName) {
        this.$router.push(`/home/order/${tab.$options.propsData.name}`);
      }
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          if (this.resData.origin == 1) {
            this.resData.origin = "广州";
          } else if (this.resData.origin == 2) {
            this.resData.origin = "杭州";
          } else {
            this.resData.origin = "未知城市";
          }
          this.activeName = "batchorderfencang";
        }
      });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$alert(res.data.msg, "错误提示", {
            confirmButtonText: "OK",
            dangerouslyUseHTMLString: true,
          });
        } else {
          this.$message.success(res.data.msg);
          this.activeName = "batchorderfencang";
          this.fileList = [];
        }
      });
    },
    handleRemove(file, fileList) {
      this.form.filelist = "";
    },
    handlePreview(file) {},
    beforeRemove(file) {},
    handleExceed(files, fileList) {
      this.$message.error("一次只能上传一个文件！");
    },
    beforeUpload(file) {},
    uploadSuccess(res, file, fileList) {
      this.form.filelist = res.data;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/batchOrderFencang.vue